import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useSelector } from "react-redux";
import moment from "moment";
ChartJS.register(ArcElement, Tooltip, Legend);

export default function DonutChart() {
  const approvedInvestments = useSelector((state) => state.approvedInvestment);
  const UndefinedapprovedInvestments = useSelector(
    (state) => state.approvedUndefinedInvestments
  );
  const filteredInvestments = approvedInvestments.filter(
    (investment) => moment(investment.maturity_date) > moment()
  );
  const data = {
    labels: ["Rated Investments", "Undefined Rate Investments"],
    datasets: [
      {
        label: "Count",
        data: [filteredInvestments.length, UndefinedapprovedInvestments.length],
        backgroundColor: ["#355c80", "#cccccc"],
        borderColor: ["#000", "#000"],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };
  return (
    <div style={{ width: "50%", fontSize: "16px" }}>
      <Doughnut height={200} options={options} data={data} />
    </div>
  );
}
